"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatiCertificatiDtoToJSON = exports.DatiCertificatiDtoFromJSONTyped = exports.DatiCertificatiDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function DatiCertificatiDtoFromJSON(json) {
    return DatiCertificatiDtoFromJSONTyped(json, false);
}
exports.DatiCertificatiDtoFromJSON = DatiCertificatiDtoFromJSON;
function DatiCertificatiDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ndgCertificati': !runtime_1.exists(json, 'ndgCertificati') ? undefined : json['ndgCertificati'],
        'ndgDaCertificare': !runtime_1.exists(json, 'ndgDaCertificare') ? undefined : json['ndgDaCertificare'],
        'totaleNdgDaCertificare': !runtime_1.exists(json, 'totaleNdgDaCertificare') ? undefined : json['totaleNdgDaCertificare'],
        'totaleNdg': !runtime_1.exists(json, 'totaleNdg') ? undefined : json['totaleNdg'],
    };
}
exports.DatiCertificatiDtoFromJSONTyped = DatiCertificatiDtoFromJSONTyped;
function DatiCertificatiDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ndgCertificati': value.ndgCertificati,
        'ndgDaCertificare': value.ndgDaCertificare,
        'totaleNdgDaCertificare': value.totaleNdgDaCertificare,
        'totaleNdg': value.totaleNdg,
    };
}
exports.DatiCertificatiDtoToJSON = DatiCertificatiDtoToJSON;
